import { PartyWithRelationships } from "modules/api/types/WorkflowDetailsPayload";
import Party from "../types/Party";

export default (partyData: PartyWithRelationships): Party => {
  const { party, relationships } = partyData;
  party.relationships = relationships;
  return party;
};
